<template>
    <section class="qualification-wall">
        <div class="qualification-title-wrap">
            <h2>企业资质</h2>
            <span class="title-watermark">QUALIFICATION</span>
        </div>
        <div class="qualification-list">
            <div class="qualification-card" v-for="item in qualifications" :key="item.id">
                <span class="qualification-name">{{ item.name }}</span>
            </div>
        </div>
    </section>
</template>

<script>
import { getHomeQualificationList } from '../api/about';

export default {
    name: 'PartnerWall',
    data() {
        return {
            qualifications: []
        };
    },
    mounted() {
        this.fetchQualifications();
    },
    methods: {
        fetchQualifications() {
            getHomeQualificationList().then(res => {
                if (res.data.code === 200 && Array.isArray(res.data.data)) {
                    this.qualifications = res.data.data;
                }
            });
        }
    }
};
</script>

<style scoped>
.qualification-wall {
    background: #fff;
    padding: 48px 0 56px 0;
    margin-bottom: 40px;
    border-radius: 20px;
    box-shadow: 0 4px 24px rgba(30, 60, 120, 0.06);
    width: 97%;
    max-width: none;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
}

.qualification-title-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 18px;
    width: 100%;
    min-width: unset;
    padding-right: 0;
    margin-left: 0;
}

.title-watermark {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -10px;
    font-size: 2.2rem;
    font-weight: 900;
    color: #1a2a47;
    opacity: 0.09;
    letter-spacing: 0.18em;
    user-select: none;
    pointer-events: none;
    z-index: 1;
    white-space: nowrap;
}

.qualification-title-wrap h2 {
    position: relative;
    z-index: 2;
    margin: 0;
    font-size: 2rem;
    font-weight: 700;
    color: #1a2a47;
    letter-spacing: 1px;
    text-align: center;
}

.qualification-list {
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
    justify-content: flex-start;
    align-items: stretch;
    padding: 0 32px;
}

.qualification-card {
    background: #f7f8fa;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(30, 60, 120, 0.06);
    padding: 32px 36px;
    min-width: 220px;
    max-width: 320px;
    flex: 1 1 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    font-weight: 600;
    color: #1a2a47;
    letter-spacing: 0.05em;
    margin-bottom: 16px;
    transition: box-shadow 0.2s, transform 0.2s;
}

.qualification-card:hover {
    box-shadow: 0 6px 24px rgba(30, 60, 120, 0.12);
    transform: translateY(-2px) scale(1.03);
}

.qualification-name {
    text-align: center;
    word-break: break-all;
}

@media (max-width: 900px) {
    .qualification-list {
        gap: 16px;
        padding: 0 8px;
    }

    .qualification-card {
        padding: 20px 10px;
        min-width: 140px;
        max-width: 100%;
        font-size: 0.98rem;
    }
}

@media (max-width: 600px) {
    .qualification-wall {
        padding: 24px 0 24px 0;
    }

    .qualification-title-wrap {
        margin-left: 12px;
        margin-bottom: 12px;
    }

    .qualification-list {
        gap: 8px;
        padding: 0 2px;
    }

    .qualification-card {
        padding: 12px 4px;
        font-size: 0.92rem;
    }
}

@media (max-width: 768px) {
    .qualification-title-wrap h2 {
        font-size: 1.18rem;
    }

    .title-watermark {
        font-size: 1.2rem;
    }
}
</style>